import React from 'react'

export const VideoPlay = (props) => (
    <div className="embed-responsive embed-responsive-16by9">
        <iframe className="embed-responsive-item" src={props.link} title="video" allowFullScreen>
        </iframe>
    </div>
)
